import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import { useMutation } from "react-query";
import {
  PatchBotMessageListFn,
  PostBotMessageListFn,
} from "../../../../Services/ChatAgent";
import CustomModal from "../../../../Shared/CustomModal";

const AddChatBotMessages = ({ initialValues, setInitialValue, refetch }) => {
  const [open, setOpen] = useState(false);

  const [question, setQuestion] = useState("");

  useEffect(() => {
    if (initialValues !== null) {
      setQuestion(initialValues?.question || "");
    }
  }, [initialValues]);

  const { mutate: AddQa, isLoading } = useMutation(PostBotMessageListFn, {
    onSuccess: (res) => {
      if (res?.data?.response_code === 200) {
        toast.success(res?.data?.message);

        refetch();
        setOpen(false);

        setQuestion("");

        setInitialValue(null);
      } else {
        toast.warn(res?.data?.message);
      }
    },
  });

  const { mutate: UpdateQa, isLoading: UpdateLoading } = useMutation(
    PatchBotMessageListFn,
    {
      onSuccess: (res) => {
        if (res?.data?.response_code === 200) {
          toast.success(res?.data?.message);

          refetch();
          setOpen(false);
          setQuestion("");
          setInitialValue(null);
        } else {
          toast.warn(res?.data?.message);
        }
      },
    },
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (initialValues !== null) {
      UpdateQa({
        question,
        q_id: initialValues?.id,
        store: localStorage.getItem("store_id"),
      });
    } else {
      AddQa({ question, store: localStorage.getItem("store_id") });
    }
  };

  function handleClose() {
    setOpen(false);
    setQuestion("");

    setInitialValue(null);
  }

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        variant="outlined"
        color="secondary"
      >
        Add
      </Button>

      <CustomModal
        open={open || Boolean(initialValues)}
        onClose={handleClose}
        title="Add Questions"
        className="!max-w-sm !w-full"
      >
        <form
          onSubmit={handleSubmit}
          className=" flex  flex-col w-full items-center  justify-center  gap-5"
        >
          <div className="w-full">
            <label className="font-semibold">Question</label>
            <input
              type="text"
              className="w-full border p-2 rounded mt-1 border-gray-500 text-black"
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              placeholder="Enter your question"
            />
          </div>

          <Button type="submit" variant="contained" color="warning">
            Save
          </Button>
        </form>
      </CustomModal>
    </>
  );
};

export default AddChatBotMessages;
